<template>
	<div>
		<div class="top-info">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="avatar-area">
							<div>
								<div style="margin-bottom: 10px;" class="company">用户名：{{userInfo.nickName}}</div>
								<div class="company">手机号：{{userInfo.phonenumber}}</div>
								<div style="margin:10px 0" class="company visible-xs-block">
									性别：{{userInfo.sex==1?'女':'男'}}</div>
								<div class="company visible-xs-block">邮箱：{{userInfo.email}}</div>
							</div>
							<div class="hidden-xs" style="margin-left: 30px;">
								<div style="margin-bottom: 10px;" class="company">性别：{{userInfo.sex==1?'女':'男'}}</div>
								<div class="company">邮箱：{{userInfo.email}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: space-between;align-items: center;margin-top: 10px;">
			<div class="mini-title1">工作经历</div>
			<el-button style="margin-left: 10px;" icon="el-icon-circle-plus-outline" size="small" type="success"
				@click="addUnit">新增工作经历</el-button>
		</div>
		<div class="review-box">
			<el-empty v-if="experiencesList.length==0" description="暂无数据"></el-empty>
			<div v-for="(item,index) in experiencesList" :key="index" class="single-item">
				<div class="review-man hidden-xs">
					<img style="width: 60px;height: 60px;" src="@/assets/images/company.png" alt="review-man">
				</div>
				<div class="content">
					<div class="name-other">
						<h6 class="headsix">{{item.companyName}}</h6>
						<div class="rating">
							<p class="text">{{item.position}}</p>
						</div>
						<p class="text">{{formatterTime(item.beginTime)}}至{{formatterTime(item.endTime)}}</p>
					</div>
					<div></div>
					<v-clamp autoresize :max-lines="3">
						{{ item.remark }}
					</v-clamp>
				</div>
			</div>
		</div>
		<b-modal ref="my-modal" title="新增工作经历" size="lg">
			<b-form>
				<div class="label-name">
					<b-form-group label="单位名称:">
						<b-form-input v-model="form.companyName" placeholder="请输入单位名称"></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="职位名称:">
						<b-form-input v-model="form.position" placeholder="请输入职位名称"></b-form-input>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="在职时间:">
						<div style="display: flex;align-items: center;">
							<b-form-datepicker v-bind="labels['zh']" label-no-date-selected="开始时间"
								v-model="form.beginTime" class="mb-2"></b-form-datepicker>
							<div>——</div>
							<b-form-datepicker v-bind="labels['zh']" label-no-date-selected="结束时间"
								v-model="form.endTime" class="mb-2"></b-form-datepicker>
						</div>
					</b-form-group>
				</div>
				<div class="label-name">
					<b-form-group label="工作描述:">
						<b-form-textarea rows="6" v-model="form.remark" placeholder="请输入工作描述"></b-form-textarea>
					</b-form-group>
				</div>
			</b-form>
			<template v-slot:modal-footer="{ ok, cancel, hide }">
				<b-button variant="success" @click="submit()">
					确定
				</b-button>
				<b-button variant="danger" @click="cancel()">
					取消
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
	import {
		getInfo
	} from "@/api/login";
	import {
		myWorkExperiences,
		addExperience
	} from "@/api/userCenter";

	export default {
		data() {
			return {
				userInfo: {},
				experiencesList: [],
				form: {
					companyName: null,
					position: null,
					beginTime: null,
					endTime: null,
					remark: null
				},
				labels: {
					zh: {
						labelPrevYear: '上一年',
						labelPrevMonth: '上个月',
						labelCurrentMonth: '当前月份',
						labelNextMonth: '下个月',
						labelNextYear: '明年',
						labelToday: '今天',
						labelSelected: '选定日期',
						labelNoDateSelected: '未选择日期',
						labelCalendar: '日历',
						labelNav: '日历导航',
						labelHelp: '使用光标键浏览日期'
					}
				}
			}
		},
		mounted() {
			getInfo().then(res => {
				this.userInfo = res.data.user
			})
			this.init()
		},
		methods: {
			init() {
				myWorkExperiences().then(res => {
					this.experiencesList = res.data
				})
			},
			formatterTime(row) {
				return row.split(' ')[0]
			},
			addUnit() {
				this.form = {
					companyName: null,
					position: null,
					beginTime: null,
					endTime: null,
					remark: null
				}
				this.$refs['my-modal'].show()
			},
			submit() {
				if (!this.form.companyName) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入单位名称！'
					})
				} else if (!this.form.position) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入职位名称！'
					})
				} else if (!this.form.beginTime) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入在职开始时间！'
					})
				} else if (!this.form.endTime) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入在职结束时间！'
					})
				} else if (this.compare(this.form.beginTime, this.form.endTime)) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '开始时间不能大于结束时间！'
					})
				} else if (!this.form.remark) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '请输入工作描述！'
					})
				} else {
					this.form.beginTime = this.form.beginTime + ' 00:00:00'
					this.form.endTime = this.form.endTime + ' 00:00:00'
					addExperience(this.form).then(res => {
						if (res.code == 200) {
							this.$message({
								showClose: true,
								type: 'success',
								message: '新增成功！'
							})
							this.init()
							this.$refs['my-modal'].hide()
						}
					})
				}
			},
			//日期比较的方法
			compare(date1, date2) {
				let dates1 = new Date(date1);
				let dates2 = new Date(date2);
				if (dates1 > dates2) {
					return true
				} else {
					return false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@media screen and (max-width: 997px) {
		.top-info {
			padding: 10px !important;
		}

		.review-man {
			text-align: center;
		}
	}

	.top-info {
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		background-image: -webkit-linear-gradient(145deg, #20c3f2 0%, #7e39fb 100%);
		padding: 25px 15px;
		border-radius: 10px;
		margin-top: 10px;
	}

	.avatar-area {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.avatar {
			width: 70px;
			height: 70px;
			border-radius: 50%;
			margin-right: 15px;
		}

		.company {
			color: #fff;
			font-size: 14px;
		}
	}

	.mini-title1 {
		padding-left: 15px;
		position: relative;
		font-weight: 600;
	}

	.mini-title1::after {
		content: "";
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
		width: 5px;
		height: 20px;
		background-color: #007BFF;
		border-radius: 5px;
	}
</style>